import { Text, TextProps } from '@shared/components/Text';
import { Link } from '@shared/components/link';
import { API } from '@shared/types/api';
import { FormattedTextProps, FormattedTextToken } from './props';

export interface FormattedTokenTextProps extends Omit<FormattedTextProps, 'tokens'> {
  token?: FormattedTextToken;
}

export function FormattedTokenText({
  children,
  token,
  highlightColor,
  mentionColor,
  ...otherProps
}: FormattedTokenTextProps) {
  const defaultProps = {
    ...otherProps,
    children,
    color: highlightColor,
  };

  if (!token) {
    return <Text {...otherProps}>{children}</Text>;
  }

  if (token.type === 'url') {
    return <LinkToken token={token} {...defaultProps} />;
  }

  if (token.type === 'mention') {
    const color = mentionColor ? mentionColor(token) : highlightColor;
    return (
      <Text weight="bold" {...otherProps} color={color}>
        {children}
      </Text>
    );
  }

  if (token.type === 'email') {
    return <LinkToken token={token} {...defaultProps} />;
  }

  if (token.type === 'hashtag') {
    return <Text weight="bold" {...defaultProps} />;
  }

  if (token.type === null) {
    return <Text {...defaultProps} />;
  }

  return <Text {...otherProps}>{children}</Text>;
}

interface LinkTokenProps extends TextProps {
  token: API.ChatMetaTokenFragment;
}

function LinkToken({ token, children, ...props }: LinkTokenProps) {
  const style = {
    color: 'inherit',
    font: 'inherit',
    textDecoration: 'inherit',
  };

  return (
    <Text weight="bold" {...props}>
      <Link href={token.href} style={style} underline={false}>
        {children}
      </Link>
    </Text>
  );
}
